import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { AnalyticsParams, PracticeListRequest, QuestionSetRequest } from 'redux/schemas/api/analytics';
import { AnalyticsDashBoardType, AnalyticsState } from 'redux/schemas/app/analytics';
import { BasicEnrollment } from 'redux/schemas/models/course';

export const getAnalyticsToken = createAsyncThunk(
  'GET_ANALYTICS_TAGS',
  getToken,
);

async function getToken(params: AnalyticsParams) {
  const { type, catalogId, institutionId, journeyCatalogId, pageIdKey, questionSetId, scenarioId, cohortCourseIds, programId } = params;
  let tokenUrl = '';
  if (type === AnalyticsDashBoardType.COURSE || type === AnalyticsDashBoardType.COHORTS) {
    tokenUrl = `/analytics/${institutionId}/course_analytics_access/${catalogId}.json`;
  }
  if (type === AnalyticsDashBoardType.PRACTICE_ANALYTICS) {
    tokenUrl = `analytics/practice_scenarios/${scenarioId}.json`;
  }
  if (type === AnalyticsDashBoardType.LEARNING_JOURNEY) {
    tokenUrl = `analytics/${institutionId}/journey_analytics_access/${journeyCatalogId}`;
  }
  if (type === AnalyticsDashBoardType.INSTITUTION) {
    tokenUrl = `analytics/${institutionId}/org_analytics_access.json`;
  }
  if (type === AnalyticsDashBoardType.LICENSE) {
    tokenUrl = pageIdKey === 'main' ? `analytics/${institutionId}/license_analytics_access.json` : `analytics/${institutionId}/merged_license_analytics_access.json`;
  }
  if (type === AnalyticsDashBoardType.QUESTION_SET) {
    tokenUrl = `/analytics/${institutionId}/courses/${catalogId}/question_sets/${questionSetId}.json`;
  }
  if (type === AnalyticsDashBoardType.COHORT_QUESTION_SET) {
    tokenUrl = `/analytics/${institutionId}/courses/${catalogId}/question_sets/cross_primary_and_cohorts/${questionSetId}.json`;
    return axios.get(tokenUrl, { params: cohortCourseIds.length > 0 ? { course_ids: cohortCourseIds.join(',') } : null }).then((response) => response.data.result);
  }
  if (type === AnalyticsDashBoardType.MENTORSHIP_PROGRAM) {
    tokenUrl = `/analytics/${institutionId}/mentorship_programs/${programId}/mentorship_program_access.json`;
  }
  return axios.get(tokenUrl).then((response) => response.data.result);
}

export const fetchQuestionSet = createAsyncThunk <AnalyticsState['questionSets'], QuestionSetRequest>(
  'FETCH_QUESTION_SET',
  async (params) => {
    const { institutionId, catalogId } = params;
    const response = await axios.get(`/analytics/${institutionId}/courses/${catalogId}/question_sets`);
    return response.data.result;
  },
);

export const fetchCohortsQuestionSet = createAsyncThunk <AnalyticsState['questionSets'], QuestionSetRequest>(
  'FETCH_COHORTS_QUESTION_SET',
  async (params) => {
    const { institutionId, catalogId } = params;
    const response = await axios.get(`/analytics/${institutionId}/courses/${catalogId}/question_sets/primary_course_quizes_and_surveys.json`);
    return response.data.result;
  },
);

export const fetchPracticeList = createAsyncThunk <AnalyticsState['practiceList'], PracticeListRequest>(
  'FETCH_PRACTICE_LIST',
  async ({ catalogId }) => {
    try {
      const response = await axios.get(`/analytics/courses/${catalogId}/course_scenarios`);
      return response.data.result;
    } catch {
      return [];
    }
  },
);


export const fetchCohorts = createAsyncThunk <BasicEnrollment[], { catalogId: string, institutionId: number, questionSetId: number }>(
  'FETCH_COHORTS_LIST',
  async ({ catalogId, institutionId, questionSetId }) => {
    try {
      const response = await axios.get(`/analytics/${institutionId}/primary_or_cohort_courses_as_admin/${catalogId}.json?question_set_id=${questionSetId}`);
      return response.data.result;
    } catch {
      return [];
    }
  },
);

export const resetQuestionSets = createAction('RESET_QUESTION_SETS');
